import React from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {
  applyFilter,
  DashboardFilterbar,
} from 'app/general/dashboards/DashboardFilterbar';
import {DashboardFilterbarSort} from 'app/general/dashboards/DashboardFilterbarSort';
import {DashboardFilterbarTeams} from 'app/general/dashboards/DashboardFilterbarTeams';
import {SearchInputField} from 'app/general/widgets/SearchInputField';
import {SORT_BY_TYPES} from 'app/utils/constants';

import {DashboardFilterUserStatus} from './DashboardFilterUserStatus';

import type {UsersLocationParamsType} from 'app/user/types';

const sortOptions = [
  SORT_BY_TYPES.DATE_JOINED_DESC,
  SORT_BY_TYPES.ALPHABETHICALLY,
];

interface Props extends WithRouterProps<UsersLocationParamsType> {
  viewingAll: boolean;
  resetFilters: () => void;
}

export const UserFilterbar = withRouter(function ({
  resetFilters,
  viewingAll,
  router,
  location,
}: Props) {
  const {query} = location;

  const apply =
    (name: string) =>
    (teamID: string): Promise<unknown> => {
      applyFilter(router, location, {
        [name]: teamID,
      });
      return Promise.resolve(true);
    };

  return (
    <DashboardFilterbar resetFilters={resetFilters} viewingAll={viewingAll}>
      <div className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0 pr-sm-2">
        <SearchInputField
          value={query.search != null ? query.search : ''}
          onChange={apply('search')}
        />
      </div>
      <div className="col-12 col-sm-6 col-lg mb-2 mb-lg-0 pr-lg-2">
        <DashboardFilterbarSort
          value={query.ordering}
          onChange={apply('ordering')}
          options={sortOptions}
          backendDefaultSort={SORT_BY_TYPES.ALPHABETHICALLY}
        />
      </div>
      <div className="col-12 col-sm-6 col-lg-3 mb-2 mb-sm-0 pr-sm-2">
        <DashboardFilterbarTeams
          hideInNoTeamsOption={true}
          value={query.team_id}
          onChange={apply('team_id')}
        />
      </div>
      <div className="col-12 col-sm-6 col-lg-3">
        <DashboardFilterUserStatus
          value={query.status}
          onChange={apply('status')}
        />
      </div>
    </DashboardFilterbar>
  );
});
